export const paymentConfig = {
  upiId: import.meta.env.VITE_UPI_ID,
  merchantName: import.meta.env.VITE_MERCHANT_NAME,
}

export const blockchainConfig = {
  rpcUrl: import.meta.env.VITE_RPC_URL,
  chainId: parseInt(import.meta.env.VITE_CHAIN_ID),
  explorerUrl: import.meta.env.VITE_EXPLORER_URL
} 